/* Generated by scripts/export-petterle-static-source.mjs. Do not edit manually. */
export const pageIndex = [
  {
    "path": "/",
    "type": "page",
    "priority": "1.0",
    "title": "Clínica Petterle | Cirurgia Vascular, Varizes e Reumatologia em Cuiabá - Clínica Petterle | Cirurgia Vascular, Varizes e Reumatologia em Cuiabá",
    "description": "Clínica Petterle em Cuiabá: Cirurgia Vascular e Reumatologia com tecnologia avançada, atendimento humanizado e cuidado especializado.",
    "canonical": "/",
    "dataUrl": "/static-data/pages/home.json"
  },
  {
    "path": "/blog/",
    "type": "archive",
    "priority": "0.8",
    "title": "Conteúdos de Saúde, Bem-Estar e Cuidados Médicos - Clínica Petterle | Cirurgia Vascular, Varizes e Reumatologia em Cuiabá",
    "description": "",
    "canonical": "/blog/",
    "dataUrl": "/static-data/pages/blog.json"
  },
  {
    "path": "/sobre-a-clinica/",
    "type": "page",
    "priority": "0.8",
    "title": "Sobre a Clínica - Clínica Petterle | Cirurgia Vascular, Varizes e Reumatologia em Cuiabá",
    "description": "",
    "canonical": "/sobre-a-clinica/",
    "dataUrl": "/static-data/pages/sobre-a-clinica.json"
  },
  {
    "path": "/equipe-medica/",
    "type": "page",
    "priority": "0.8",
    "title": "Equipe - Clínica Petterle | Cirurgia Vascular, Varizes e Reumatologia em Cuiabá",
    "description": "",
    "canonical": "/equipe-medica/",
    "dataUrl": "/static-data/pages/equipe-medica.json"
  },
  {
    "path": "/especialidades/",
    "type": "page",
    "priority": "0.8",
    "title": "Áreas - Clínica Petterle | Cirurgia Vascular, Varizes e Reumatologia em Cuiabá",
    "description": "",
    "canonical": "/especialidades/",
    "dataUrl": "/static-data/pages/especialidades.json"
  },
  {
    "path": "/convenios/",
    "type": "page",
    "priority": "0.7",
    "title": "Convênios - Clínica Petterle | Cirurgia Vascular, Varizes e Reumatologia em Cuiabá",
    "description": "",
    "canonical": "/convenios/",
    "dataUrl": "/static-data/pages/convenios.json"
  },
  {
    "path": "/agendar-consulta/",
    "type": "page",
    "priority": "0.8",
    "title": "Agendar - Clínica Petterle | Cirurgia Vascular, Varizes e Reumatologia em Cuiabá",
    "description": "",
    "canonical": "/agendar-consulta/",
    "dataUrl": "/static-data/pages/agendar-consulta.json"
  },
  {
    "path": "/cirurgia-vascular-cuiaba/",
    "type": "page",
    "priority": "0.8",
    "title": "Vascular - Clínica Petterle | Cirurgia Vascular, Varizes e Reumatologia em Cuiabá",
    "description": "",
    "canonical": "/cirurgia-vascular-cuiaba/",
    "dataUrl": "/static-data/pages/cirurgia-vascular-cuiaba.json"
  },
  {
    "path": "/tratamento-de-varizes-cuiaba/",
    "type": "page",
    "priority": "0.8",
    "title": "Varizes - Clínica Petterle | Cirurgia Vascular, Varizes e Reumatologia em Cuiabá",
    "description": "",
    "canonical": "/tratamento-de-varizes-cuiaba/",
    "dataUrl": "/static-data/pages/tratamento-de-varizes-cuiaba.json"
  },
  {
    "path": "/reumatologia-cuiaba/",
    "type": "page",
    "priority": "0.8",
    "title": "Reumato - Clínica Petterle | Cirurgia Vascular, Varizes e Reumatologia em Cuiabá",
    "description": "",
    "canonical": "/reumatologia-cuiaba/",
    "dataUrl": "/static-data/pages/reumatologia-cuiaba.json"
  },
  {
    "path": "/exames-e-procedimentos/",
    "type": "page",
    "priority": "0.7",
    "title": "Exames - Clínica Petterle | Cirurgia Vascular, Varizes e Reumatologia em Cuiabá",
    "description": "",
    "canonical": "/exames-e-procedimentos/",
    "dataUrl": "/static-data/pages/exames-e-procedimentos.json"
  },
  {
    "path": "/politica-de-privacidade-2/",
    "type": "legal",
    "priority": "0.3",
    "title": "Política de Privacidade - Clínica Petterle | Cirurgia Vascular, Varizes e Reumatologia em Cuiabá",
    "description": "",
    "canonical": "/politica-de-privacidade-2/",
    "dataUrl": "/static-data/pages/politica-de-privacidade-2.json"
  },
  {
    "path": "/termos-de-uso/",
    "type": "legal",
    "priority": "0.3",
    "title": "Termos de Uso - Clínica Petterle | Cirurgia Vascular, Varizes e Reumatologia em Cuiabá",
    "description": "",
    "canonical": "/termos-de-uso/",
    "dataUrl": "/static-data/pages/termos-de-uso.json"
  },
  {
    "path": "/aneurisma-de-aorta-sintomas-diagnostico-e-tratamento/",
    "type": "post",
    "priority": "0.7",
    "title": "Aneurisma de Aorta: o perigo silencioso que quase ninguém quer encarar - Clínica Petterle | Cirurgia Vascular, Varizes e Reumatologia em Cuiabá",
    "description": "",
    "canonical": "/aneurisma-de-aorta-sintomas-diagnostico-e-tratamento/",
    "dataUrl": "/static-data/pages/aneurisma-de-aorta-sintomas-diagnostico-e-tratamento.json"
  },
  {
    "path": "/sintomas-de-fibromialgia-quando-buscar-um-reumatologista/",
    "type": "post",
    "priority": "0.7",
    "title": "Sintomas de fibromialgia: quando é hora de procurar um reumatologista? - Clínica Petterle | Cirurgia Vascular, Varizes e Reumatologia em Cuiabá",
    "description": "",
    "canonical": "/sintomas-de-fibromialgia-quando-buscar-um-reumatologista/",
    "dataUrl": "/static-data/pages/sintomas-de-fibromialgia-quando-buscar-um-reumatologista.json"
  },
  {
    "path": "/como-saber-se-minhas-varizes-precisam-de-cirurgia/",
    "type": "post",
    "priority": "0.7",
    "title": "Como saber se minhas varizes precisam de cirurgia? - Clínica Petterle | Cirurgia Vascular, Varizes e Reumatologia em Cuiabá",
    "description": "",
    "canonical": "/como-saber-se-minhas-varizes-precisam-de-cirurgia/",
    "dataUrl": "/static-data/pages/como-saber-se-minhas-varizes-precisam-de-cirurgia.json"
  },
  {
    "path": "/o-que-causa-varizes-saiba-os-fatores-de-risco-e-como-prevenir/",
    "type": "post",
    "priority": "0.7",
    "title": "O Que Causa Varizes? Saiba os Fatores de Risco e Como Prevenir - Clínica Petterle | Cirurgia Vascular, Varizes e Reumatologia em Cuiabá",
    "description": "",
    "canonical": "/o-que-causa-varizes-saiba-os-fatores-de-risco-e-como-prevenir/",
    "dataUrl": "/static-data/pages/o-que-causa-varizes-saiba-os-fatores-de-risco-e-como-prevenir.json"
  },
  {
    "path": "/categorias/varizes-e-circulacao/",
    "type": "category",
    "priority": "0.5",
    "title": "Varizes e Circulação Archives - Clínica Petterle | Cirurgia Vascular, Varizes e Reumatologia em Cuiabá",
    "description": "",
    "canonical": "/categorias/varizes-e-circulacao/",
    "dataUrl": "/static-data/pages/categorias-varizes-e-circulacao.json"
  },
  {
    "path": "/categorias/doencas-reumatologicas/",
    "type": "category",
    "priority": "0.5",
    "title": "Doenças Reumatológicas Archives - Clínica Petterle | Cirurgia Vascular, Varizes e Reumatologia em Cuiabá",
    "description": "",
    "canonical": "/categorias/doencas-reumatologicas/",
    "dataUrl": "/static-data/pages/categorias-doencas-reumatologicas.json"
  }
] as const;
export const redirects = [
  {
    "from": "/sobre/",
    "to": "/sobre-a-clinica/"
  },
  {
    "from": "/especialistas/",
    "to": "/equipe-medica/"
  },
  {
    "from": "/areas/",
    "to": "/especialidades/"
  },
  {
    "from": "/contato/",
    "to": "/agendar-consulta/"
  },
  {
    "from": "/wp-sitemap.xml",
    "to": "/sitemap_index.xml"
  },
  {
    "from": "/politica-de-privacidade/",
    "to": "/politica-de-privacidade-2/"
  }
] as const;
